import * as React from 'react'

import { styled } from '~/styled'
import { Override } from '~/utilities/types'

// default styling lifted from https://www.zachleat.com/web/fluid-images/#copy-and-paste
// (potentially unnecessary now we've moved to Tailwind)
export const StyledImage = styled('img', {
  base: ['align-middle', 'max-w-full'],
  variants: {
    fluid: {
      true: [
        "[[src$='.svg']]:h-auto",
        "[[src$='.svg']]:max-w-none",
        "[[src$='.svg']]:w-full",
        '[[width]]:[[height]]:h-auto',
        '[[width]]:w-auto'
      ]
    }
  }
})

type ImageProps = Override<
  React.ComponentProps<typeof StyledImage>,
  { as?: never }
>

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  (props, ref) => <StyledImage {...props} ref={ref} />
)

Image.displayName = 'Image'
